import { LOCALE_META } from './constants';

/** Apply document-level RTL/LTR and lang for the whole web app. */
export function applyDocumentDirection(locale) {
  if (typeof document === 'undefined') return;
  const meta = LOCALE_META[locale] || LOCALE_META.en;
  const dir = meta.dir;
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', meta.bcp47);
  document.body.classList.toggle('rtl', dir === 'rtl');
  document.body.classList.toggle('ltr', dir === 'ltr');
}

/** Logical margin helper for mirrored layouts in styled-components. */
export function logicalStart(locale, ltrValue, rtlValue) {
  const meta = LOCALE_META[locale] || LOCALE_META.en;
  return meta.dir === 'rtl' ? rtlValue : ltrValue;
}

/** Flip directional icons (chevrons, arrows) in RTL. */
export function shouldMirrorIcon(locale) {
  const meta = LOCALE_META[locale] || LOCALE_META.en;
  return meta.dir === 'rtl';
}
